import { request, requestList } from '../../../network';
import { ListData, ListDataRequestParams } from '../../ui';
export interface PatientQuestionnaireDataModel {
  id: number;
  questionnaire_name: string;
  completion_date: string;
  job_id: string;
  questionnaire_status: string;
  created_at: string;
  reminder_date: string;
  patient: number;
  questionnaire: number;
  completed_questionnaire: number;
}

export interface QuestionnaireModel {
  id: number;
  name: string;
  instructions: string;
  organization: number;
  questionnaire: number;
}

export const getPatientQuestionnaireData = async (
  data?: ListDataRequestParams,
  patientId?: number
): Promise<ListData<PatientQuestionnaireDataModel>> => {
  const combinedData = {
    ...data,
    patient: patientId,
  };
  const response = await requestList(
    '/api/questionnaire_reminder_jobs/',
    combinedData
  );

  return response;
};

export const getQuestionnaires = async (): Promise<
  ListData<QuestionnaireModel>
> => {
  const response = await requestList('/api/questionnaires/');

  return response;
};

export const assignQuestionnaire = async (
  questionnaireId: number,
  patientId: number,
  dueDate: string
): Promise<void> => {
  const dueDateObj = typeof dueDate === 'string' ? new Date(dueDate) : dueDate;
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  dueDateObj.setHours(0, 0, 0, 0);

  const diffInTime = dueDateObj.getTime() - currentDate.getTime();
  const interval = Math.ceil(diffInTime / (1000 * 3600 * 24));

  const response = await request({
    path: '/api/create_questionnaire_reminder/',
    method: 'POST',
    body: {
      questionnaire_id: questionnaireId,
      patient_id: patientId,
      interval: interval,
    },
  });

  if (response.ok) {
    return response.data;
  }

  throw new Error(response.errorMessage);
};

export const sendQuestionnaireReminder = async (postData: {
  patient_id: number;
}): Promise<{ Success: 'Questionnaire reminder sent successfully' }> => {
  const response = await request({
    path: '/api/resend_questionnaire_reminder/',
    method: 'POST',
    body: postData,
  });

  if (response.ok) {
    return response.data;
  }

  throw new Error(response.errorMessage);
};
